import React from 'react'
import { ToggleButtonGroup, ToggleButton } from '@mui/material'

export const TOGGLE_TYPES = {
  weekly: 'weekly',
  yearly: 'yearly',
}

interface ToggleProps {
  value: string
  onChange: (value: string) => void
}

function Toggle({ value, onChange }: ToggleProps) {
  const handleChange = (
    _event: React.MouseEvent<HTMLElement>,
    newValue: string | null
  ) => {
    if (newValue !== null) {
      onChange(newValue)
    }
  }

  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={handleChange}
      sx={{
        backgroundColor: '#E0E0E0',
        '& .MuiToggleButton-root': {
          '&.Mui-selected': {
            backgroundColor:
              value === TOGGLE_TYPES.weekly ? '#E0F7FA' : '#FFF3E0',
          },
        },
      }}
    >
      <ToggleButton value={TOGGLE_TYPES.weekly}>Weekly</ToggleButton>
      <ToggleButton value={TOGGLE_TYPES.yearly}>This School Year</ToggleButton>
    </ToggleButtonGroup>
  )
}

export default Toggle
